export { default as ProductMetafieldFilter } from './product-filter-type.component'